import type { Underlying } from 'models/underlying';
import type { UnderlyingCodeType, UnderlyingStrike } from 'models/underlying/base';
import type { ForexUnderlying } from 'models/underlying/forex';
import { isCommodityUnderlying, isEquityUnderlying, isForexUnderlying } from 'utils/underlying/typeGuards';
import { getUnderlyingCode } from 'utils/underlying/underlying-code';

export function updateStrike(underlying: Underlying, key: keyof UnderlyingStrike, value: unknown): Underlying {
  if (isEquityUnderlying(underlying) || isCommodityUnderlying(underlying)) {
    return { ...underlying, strike: { ...underlying.strike!, [key]: value } };
  }

  return underlying;
}

export function updateWeight(underlying: Underlying, value: number): Underlying {
  return { ...underlying, weight: value };
}

export function updateCutOff(underlying: Underlying, value: string): Underlying {
  if (isForexUnderlying(underlying)) {
    return { ...underlying, cutOff: value };
  }

  return underlying;
}

export function displayUnderlyingCode(defaultUnderlyingCodeType: UnderlyingCodeType, underlying?: Underlying): string {
  if (!underlying) {
    return 'Undefined';
  }
  return getUnderlyingCode(underlying, defaultUnderlyingCodeType);
}

export function displayUnderlyingCodeWithCutoff(
  defaultUnderlyingCodeType: UnderlyingCodeType,
  underlying?: Underlying,
): string {
  if (!underlying) {
    return 'Undefined';
  }
  const code = getUnderlyingCode(underlying, defaultUnderlyingCodeType);
  const forexUnderlying = underlying as ForexUnderlying;
  const cutOff = forexUnderlying.cutOff;
  if (cutOff) {
    return `${code} ${cutOff}`;
  }

  return code;
}

export function displayUnderlyingCutoff(underlying?: Underlying): string {
  const forexUnderlying = underlying as ForexUnderlying;
  if (!forexUnderlying?.cutOff) {
    return '';
  }

  return `${forexUnderlying?.cutOff}`;
}

export const emptyUnderlyings: ReadonlyArray<Underlying> = [];
